import { requests } from '@/libs/axios/axios'
import { OrganizationsEndpoints } from '../organizations-endpoints'

export async function deleteOrganizationUser(orgId: number, userId: number) {
  return requests.delete(`${OrganizationsEndpoints.ORGANIZATIONS}/${orgId}/users/${userId}`)
}

export default deleteOrganizationUser
